(()=>{
  const initialize=scope=>{
    scope.querySelectorAll('[data-v3-product]').forEach(section=>{
      if(section.dataset.v3Ready)return;
      section.dataset.v3Ready='true';
      const form=section.querySelector('[data-product-form]');
      const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);
      const copy=JSON.parse(section.querySelector('[data-v3-product-copy]').textContent);
      const fields=Array.from(section.querySelectorAll('[data-option-position]'));
      const select=section.querySelector('[data-variant-select]');
      const button=section.querySelector('[data-add-button]');
      const message=section.querySelector('[data-product-message]');
      const price=section.querySelector('[data-price]');
      const gallery=section.querySelector('[data-gallery]');
      const photos=Array.from(gallery.querySelectorAll('[data-v3-photo]'));
      const thumbnails=Array.from(section.querySelectorAll('[data-v3-thumb]'));
      const counter=section.querySelector('[data-v3-photo-count]');
      const sticky=section.querySelector('[data-v3-sticky]');
      const stickyButton=section.querySelector('[data-v3-sticky-add]');
      const stickyPrice=section.querySelector('[data-v3-sticky-price]');
      const stickyOptions=section.querySelector('[data-v3-sticky-options]');
      const buyRow=section.querySelector('[data-v3-buy-row]');
      const mobile=window.matchMedia('(max-width:699px)');
      const reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
      const colorIndex=fields.findIndex(field=>field.dataset.optionName==='Color');
      const loadedVariant=variants.find(variant=>String(variant.id)===select.value);
      const cataloguePhoto=photos.find(photo=>photo.classList.contains('el-gallery-catalogue'));
      const catalogueColor=section.dataset.catalogueColor||loadedVariant?.options[colorIndex];
      const root=document.body.dataset.rootUrl||'/';
      const money=value=>new Intl.NumberFormat(document.body.dataset.locale||'es-ES',{style:'currency',currency:document.body.dataset.currency||'EUR'}).format(value/100);
      const fallbackColorPhotos={
        'kathy-conjunto-de-punto-de-dos-piezas':{'Beige':'kathy-beige-premium_','Negro':'kathy-nero-premium_','Marrón':'kathy-marrone-premium_','Rosa':'kathy-rosa-premium_','Verde':'kathy-verde-premium_','Gris':'kathy-grigio-premium_','Azul':'kathy-blu-premium_'},
        'ettore-chaqueta-efecto-ante':{'Negro':'ettore-nero','Gris topo':'ettore-tortora','Verde oliva':'ettore-verde-oliva','Azul empolvado':'ettore-azzurro-polvere'}
      };
      let colorPhotos={...(fallbackColorPhotos[section.dataset.productHandle]||{}),...(copy.colorImages||{})};
      let selectedPhotoId=photos[0]?.dataset.v3Photo;
      let submitting=false;
      let framePending=false;
      let selectedVariant=loadedVariant;
      const filename=photo=>{
        const source=photo.querySelector('img')?.getAttribute('src');
        if(!source)return '';
        try{return decodeURIComponent(new URL(source,location.href).pathname.split('/').pop());}catch{return '';}
      };
      const visiblePhotos=()=>photos.filter(photo=>!photo.hidden);
      const updateCounter=()=>{
        const visible=visiblePhotos();
        gallery.parentElement.classList.toggle('is-single-photo',visible.length<2);
        const index=Math.max(0,visible.findIndex(photo=>photo.dataset.v3Photo===selectedPhotoId));
        if(counter)counter.textContent=(index+1)+' / '+visible.length;
        thumbnails.forEach(thumb=>{
          const photo=photos.find(item=>item.dataset.v3Photo===thumb.dataset.v3Thumb);
          thumb.hidden=photo?.hidden??true;
          const active=thumb.dataset.v3Thumb===selectedPhotoId;
          thumb.classList.toggle('is-active',active);
          thumb.setAttribute('aria-pressed',String(active));
        });
        section.querySelectorAll('[data-v3-photo-prev],[data-v3-photo-next]').forEach(control=>control.disabled=visible.length<2);
      };
      const activatePhoto=(photo,animate=true)=>{
        if(!photo||photo.hidden)return;
        selectedPhotoId=photo.dataset.v3Photo;
        photos.forEach(item=>item.classList.toggle('is-active',item===photo));
        if(mobile.matches)gallery.scrollTo({left:photo.offsetLeft-gallery.offsetLeft,behavior:animate&&!reduced.matches?'smooth':'instant'});
        updateCounter();
      };
      const mappedPhoto=(variant,color)=>{
        const studio=photos.find(photo=>photo.hasAttribute('data-v3-color')&&photo.dataset.v3Color===color);
        if(studio)return studio;
        const associated=variant?.featured_image?.id;
        if(associated){const matched=photos.find(photo=>photo.dataset.v3Photo===String(associated));if(matched)return matched;}
        const imageName=colorPhotos[color];
        if(imageName)return photos.find(photo=>{const file=filename(photo);return file===imageName||file.startsWith(imageName);});
        return undefined;
      };
      const updateGallery=(variant,color,animate=true)=>{
        const actual=mappedPhoto(variant,color);
        const principal=cataloguePhoto&&color===catalogueColor?cataloguePhoto:actual;
        if(principal){
          photos.forEach(photo=>{photo.hidden=photo!==principal;});
        }else if(!cataloguePhoto){
          photos.forEach(photo=>{photo.hidden=false;});
        }
        activatePhoto(principal||photos.find(photo=>!photo.hidden),animate);
      };
      const chosenValues=()=>fields.map(field=>field.querySelector('input:checked')?.value);
      const updateSizeAvailability=chosen=>{
        fields.forEach((field,index)=>{
          if(field.dataset.optionName!=='Talla')return;
          field.querySelectorAll('input[type=radio]').forEach(input=>{
            const matching=variants.filter(variant=>variant.options[index]===input.value&&variant.options.every((value,other)=>other===index||!chosen[other]||value===chosen[other]));
            input.disabled=!matching.some(variant=>variant.available);
            input.closest('label').classList.toggle('is-unavailable',input.disabled);
            input.setAttribute('aria-label',input.value+(input.disabled?' · '+section.dataset.soldOut:''));
          });
        });
      };
      const updateSelection=(updateUrl=false,animate=false)=>{
        const chosen=chosenValues();
        updateSizeAvailability(chosen);
        const complete=chosen.every(Boolean);
        const exact=complete?variants.find(variant=>variant.options.every((value,index)=>value===chosen[index])):undefined;
        const partial=variants.find(variant=>variant.available&&variant.options.every((value,index)=>!chosen[index]||value===chosen[index]));
        selectedVariant=exact;
        fields.forEach(field=>{field.querySelector('[data-option-label]').textContent=field.querySelector('input:checked')?.dataset.optionDisplayLabel||field.querySelector('input:checked')?.value||'';});
        select.disabled=!exact;
        if(exact)select.value=String(exact.id);
        const noSize=fields.some(field=>field.dataset.optionName==='Talla'&&!field.querySelector('input:checked'));
        button.disabled=!exact?.available||submitting;
        button.textContent=submitting?section.dataset.addingText:noSize?section.dataset.chooseSize:exact?.available?section.dataset.addText:section.dataset.unavailableText;
        stickyButton.disabled=complete&&!exact?.available||submitting;
        stickyButton.textContent=submitting?section.dataset.addingText:noSize?section.dataset.chooseSize:section.dataset.addText;
        const pricing=exact||partial;
        if(pricing){
          const amount=pricing.price;
          const reference=Number(pricing.compare_at_price)||0;
          const saving=reference>amount?Math.round((reference-amount)*100/reference):0;
          const comparison=price.querySelector('[data-price-base]');
          const savings=price.querySelector('[data-price-savings]');
          if(comparison){comparison.hidden=!saving;comparison.textContent=money(reference);}
          if(savings){savings.hidden=!saving;savings.textContent='Ahorras '+saving+' %';}
          price.querySelector('[data-price-current]').textContent=money(amount);

          price.querySelector('[data-price-reference]')?.replaceChildren(document.createTextNode(money(pricing.price)));
          stickyPrice.textContent=money(amount);
        }
        stickyOptions.textContent=fields.map(field=>field.querySelector('input:checked')?.dataset.optionDisplayLabel||field.querySelector('input:checked')?.value).filter(Boolean).join(' / ');
        if(updateUrl&&exact){const url=new URL(location.href);url.searchParams.set('variant',exact.id);history.replaceState({},'',url);}
        if(!submitting)message.textContent=complete&&!exact?section.dataset.unavailableText:'';
        updateGallery(exact||partial,chosen[colorIndex],animate);
      };
      fields.forEach(field=>{
        field.addEventListener('change',()=>updateSelection(true,true));

      });
      thumbnails.forEach(thumb=>thumb.addEventListener('click',()=>activatePhoto(photos.find(photo=>photo.dataset.v3Photo===thumb.dataset.v3Thumb))));
      section.querySelectorAll('[data-v3-photo-prev],[data-v3-photo-next]').forEach(control=>control.addEventListener('click',()=>{
        const visible=visiblePhotos();
        const index=visible.findIndex(photo=>photo.dataset.v3Photo===selectedPhotoId);
        const direction=control.hasAttribute('data-v3-photo-next')?1:-1;
        activatePhoto(visible[(index+direction+visible.length)%visible.length]);
      }));
      gallery.addEventListener('scroll',()=>{
        if(!mobile.matches||framePending)return;
        framePending=true;
        requestAnimationFrame(()=>{
          framePending=false;
          const edge=gallery.getBoundingClientRect().left;
          const closest=visiblePhotos().reduce((best,photo)=>!best||Math.abs(photo.getBoundingClientRect().left-edge)<Math.abs(best.getBoundingClientRect().left-edge)?photo:best,null);
          if(closest){selectedPhotoId=closest.dataset.v3Photo;updateCounter();}
        });
      },{passive:true});
      mobile.addEventListener('change',()=>activatePhoto(photos.find(photo=>photo.dataset.v3Photo===selectedPhotoId),false));
      const offer=section.querySelector('[data-v3-offer]');
      const code=price.dataset.code;
      if(offer&&code){
        offer.hidden=false;
        const copyButton=offer.querySelector('[data-v3-copy-code]');
        copyButton.textContent=code;
        copyButton.setAttribute('aria-label',section.dataset.copyText+' '+code);
        offer.querySelector('[data-v3-offer-description]').textContent=copy.promo.replace('__CODE__',code).replace('__PERCENT__','10');
        copyButton.addEventListener('click',async()=>{
          try{
            await navigator.clipboard.writeText(code);
            copyButton.textContent=section.dataset.copiedText;
            copyButton.setAttribute('aria-label',section.dataset.copiedText);
            setTimeout(()=>{copyButton.textContent=code;copyButton.setAttribute('aria-label',section.dataset.copyText+' '+code);},2200);
          }catch{copyButton.textContent=code;}
        });
      }
      const replaceCart=html=>{
        if(!html)return false;
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const replacement=parsed.querySelector('#shopify-section-el-cart-drawer');
        const current=document.querySelector('#shopify-section-el-cart-drawer');
        if(!replacement||!current)return false;
        current.replaceWith(replacement);
        const drawer=document.querySelector('#ElCartDrawer');
        document.querySelectorAll('[data-cart-count]').forEach(badge=>{badge.textContent=drawer.dataset.itemCount;badge.hidden=Number(drawer.dataset.itemCount)===0;});
        drawer.addEventListener('click',event=>{if(event.target===drawer){const bounds=drawer.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)drawer.close();}});
        drawer.showModal();
        drawer.querySelector('button,a')?.focus();
        return true;
      };
      form.addEventListener('submit',async event=>{
        if(!window.fetch)return;
        event.preventDefault();
        if(submitting||!selectedVariant?.available||!form.reportValidity())return;
        submitting=true;
        updateSelection();
        message.textContent='';
        try{
          const data=new FormData(form);
          data.append('sections','el-cart-drawer');
          data.append('sections_url',location.pathname);
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||section.dataset.errorText);
          if(!replaceCart(result.sections?.['el-cart-drawer']))location.href=document.body.dataset.cartUrl||root+'cart';
        }catch(error){message.textContent=error.message||section.dataset.errorText;}
        finally{
          const errorText=message.textContent;
          submitting=false;
          updateSelection();
          if(errorText)message.textContent=errorText;
        }
      });
      stickyButton.addEventListener('click',()=>{
        const unchosen=fields.find(field=>!field.querySelector('input:checked'));
        if(unchosen){unchosen.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'center'});unchosen.querySelector('input:not(:disabled)')?.focus({preventScroll:true});}
        else form.requestSubmit(button);
      });
      const updateSticky=()=>{
        sticky.hidden=!mobile.matches||buyRow.getBoundingClientRect().bottom>=0||section.getBoundingClientRect().bottom<=120;
      };
      const observer=new IntersectionObserver(updateSticky,{threshold:[0,1]});
      observer.observe(buyRow);
      observer.observe(section);
      window.addEventListener('scroll',updateSticky,{passive:true});
      mobile.addEventListener('change',updateSticky);
      updateSelection();
      updateSticky();
      if(section.dataset.colorMapUrl){
        fetch(section.dataset.colorMapUrl,{headers:{Accept:'application/json'}}).then(response=>response.ok?response.json():null).then(data=>{
          if(data?.[section.dataset.productHandle]){colorPhotos={...colorPhotos,...data[section.dataset.productHandle]};updateSelection();}
        }).catch(()=>{});
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
